module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hrms75e-detail-tab4"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab4"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRMS75EC5']['10']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-6 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC5']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.detail.desc_codempid))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-6 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC5']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.detail.desc_codcomp))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-6 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC5']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.detail.desc_codpos))])])])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detailTab4Columns,
      "data": _vm.detail.table,
      "searchDisp": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 "
  }, [_c('button', {
    staticClass: "btn bg-color-skin pull-right",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#hrms75e-popup-tab4"
    },
    on: {
      "click": function($event) {
        _vm.togglePopupDetailTab4()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC5']['90']))])])])]), _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "labelsButton": _vm.labelsButton,
      "detailTab4Popup": _vm.detailTab4Popup,
      "detailTab4PopupColumns": _vm.detailTab4PopupColumns,
      "setAddCodcours": _vm.setAddCodcours
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78cc429f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms75e/detailTab4.vue
// module id = 3903
// module chunks = 1